/*
	Tienda en el menú lateral (Módulos Claros, Fase 1, 2026-11-01).
	- «Ventas» junta Control de Ventas (38 kitSales), Nueva Venta (66 newSale), Maestros (68 teacherBoard) y Metas y Bonos
	  (67 salesGoals): las cuatro rutas siguen vivas (el backend revisa permisos por la ruta) y abren la misma pantalla, pero en
	  el menú sale UNA entrada, la de la primera que la persona tenga con Navegar.
	- «Control de Entregas» se llama «Entregas».
	- Finanzas › Artículos (33 owedArticles) sale del menú solo para quien ya ve Ventas; quien no la tiene (Contabilidad,
	  Servicios Académicos, Cobros, RRHH) lo conserva (Esteban, 2026-11-01: no quitarle acceso a nadie).
	Los nombres de ct_sections no se tocan (Roles los sigue enseñando como están).
*/
export const RUTAS_VENTAS: string[] = ["kitSales", "newSale", "teacherBoard", "salesGoals"];
export const FUERA_DEL_MENU: string[] = ["owedArticles"];
export const NOMBRE_EN_MENU: { [codigo: string]: string } = {
	kits: "Entregas",
	kitSales: "Ventas", newSale: "Ventas", teacherBoard: "Ventas", salesGoals: "Ventas"
};

const NAVEGAR = 1;

/** ¿Sale esta sección en el menú? Ventas solo una vez (la primera ruta de RUTAS_VENTAS con Navegar). */
export const seccionEnMenu = (codigo: string, permisos: any): boolean => {
	if (FUERA_DEL_MENU.includes(codigo))
		return !RUTAS_VENTAS.some((ruta) => ((permisos?.[ruta]?.binary_quintet_RCUDN_permissions || 0) & NAVEGAR) > 0);
	if (!RUTAS_VENTAS.includes(codigo)) return true;
	const primera = RUTAS_VENTAS.find((ruta) => ((permisos?.[ruta]?.binary_quintet_RCUDN_permissions || 0) & NAVEGAR) > 0);
	return primera === codigo;
};
